module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_5_2-c36267b3a45a24a6a77ce761a9af8ec6.png";